import React, { useEffect, useMemo, useRef, useState } from 'react';
import { BulbOutlined } from '@ant-design/icons';

const TipsRotator = ({ tips = [], intervalMs = 4000, fadeMs = 300, style }) => {
  const safeTips = useMemo(
    () => (Array.isArray(tips) && tips.length ? tips : []),
    [tips],
  );
  const [idx, setIdx] = useState(() => {
    try {
      return safeTips.length > 0
        ? Math.floor(Math.random() * safeTips.length)
        : 0;
    } catch (_) {
      return 0;
    }
  });
  const [visible, setVisible] = useState(true);
  const timerRef = useRef(null);
  const fadeRef = useRef(null);

  useEffect(() => {
    if (safeTips.length === 0) return;
    const loop = () => {
      setVisible(false);
      fadeRef.current = setTimeout(() => {
        setIdx(prev => {
          if (safeTips.length <= 1) return prev;
          let next = prev;
          // 違うインデックスをランダム選択
          while (next === prev) {
            next = Math.floor(Math.random() * safeTips.length);
          }
          return next;
        });
        setVisible(true);
      }, fadeMs);
    };
    timerRef.current = setInterval(loop, Math.max(1500, intervalMs));
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
      if (fadeRef.current) clearTimeout(fadeRef.current);
    };
  }, [safeTips.length, intervalMs, fadeMs]);

  if (safeTips.length === 0) return null;

  return (
    <div
      style={{
        marginTop: 16,
        textAlign: 'left',
        color: '#595959',
        fontSize: 13,
        lineHeight: 1.6,
        padding: '8px 12px',
        borderRadius: 8,
        background:
          'linear-gradient(135deg, rgba(255, 253, 231, 0.6) 0%, rgba(255, 249, 189, 0.6) 100%)',
        border: '1px solid rgba(255, 236, 61, 0.45)',
        boxShadow: '0 2px 8px rgba(255, 214, 0, 0.06)',
        opacity: visible ? 1 : 0,
        transition: `opacity ${fadeMs}ms ease`,
        ...style,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
        <span style={{ color: '#faad14', lineHeight: 1 }}>
          <BulbOutlined />
        </span>
        <span style={{ flex: 1, display: 'inline-block' }}>
          {safeTips[idx]}
        </span>
      </div>
    </div>
  );
};

export default TipsRotator;
